<!--
 * $Description: 
 * $Author: Betway
 * @最后编辑: Betway
 * $Date: 2020年03月13日 10:18:19 +0800
 * @最后修改时间: 2022-06-07 10:35:04
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Roster\RosterFormRecord\viewRosterFormRecord.vue
 -->
<template>
  <noContent v-if="RosterRecordTitle === null" />

  <ContentLayout
    v-else
    widthClass=" min-1200"
    backgroundClass="transparent"
    pad="0"
    :delBtn="hasBtn('delete-admin-roster-form-record')"
    :initData="RosterRecordData"
    @change="(changed) => (isChanged = changed)"
    :checkData="[
      'roster_form_record_title',
      'roster_form_record_description',
      'remarks',
    ]"
    @delete="
      $confirmDo($t('label_essweb_admin_RosterFormRecord_list_title')).then(
        (res) => {
          res ? toDeleteRecord() : null;
        }
      )
    "
    :editBtn="
      !iSEdited &&
      RosterRecordData &&
      RosterRecordData.status_uuid === 'Draft' &&
      hasBtn('edit-admin-roster-form-record')
    "
    @edit="iSEdited = true"
    :title="RosterRecordTitle"
  >
    <template v-slot:appendTitle>
      <StatusChip
        icon
        content-class="mx-2"
        :slideColor="RosterRecordData.approval_tint_color"
        :bgColor="RosterRecordData.approval_bg_color"
      >
        <template v-slot:status>
          {{ $getCommonLangValue(RosterRecordData.status_detail) }}
        </template>
      </StatusChip>
      <!-- <v-chip small class="pl-0 pr-2 mr-4" pill v-if="RosterRecordData">
        <svg-icon
          size="18"
          :fill="
            RosterRecordData.status_uuid == 'Draft'
              ? '#8490AD'
              : RosterRecordData.status_uuid == 'Publishing' ||
                RosterRecordData.status_uuid == 'Submiting'
              ? 'purple'
              : RosterRecordData.status_uuid == 'Published' ||
                RosterRecordData.status_uuid == 'Submited'
              ? 'green'
              : 'grey'
          "
          iconClass="LabeledColour"
          class="mr-1"
        />
        <template
          v-if="
            RosterRecordData.status_uuid == 'Publishing' ||
            RosterRecordData.status_uuid == 'Submiting'
          "
        >
          {{ $getCommonLangValue(RosterRecordData.approval_status_name) }}({{
            RosterRecordData.status_uuid == "Publishing"
              ? $t("label_essweb_RosterFormRecord_form_plannedRosterLabel")
              : $t("label_essweb_RosterFormRecord_form_actualRosterLabel")
          }})
        </template>
        <template v-else>
          {{ $getCommonLangValue(RosterRecordData.status_name) }}
        </template>
      </v-chip> -->
      <v-btn
        icon
        small
        :color="
          Number(RosterRecordData.is_locked) == 1
            ? 'text--primary'
            : 'text--secondary text--lighten-1'
        "
      >
        <i class="material-icons-round md-18 mt-1" left>{{
          Number(RosterRecordData.is_locked) == 1 ? "lock" : "lock_open"
        }}</i>
      </v-btn>
    </template>
    <template v-slot:nav-actions>
      <v-btn
        icon
        class="primary mr-4"
        color="white"
        width="40"
        height="40"
        v-if="curTab == 'tab-2'"
        @click="
          $confirmWarn(
            $t('label_essweb_RosterRecord_list_exportOutBtnLabel'),
            $t('message_essweb_system_operation_export_outLabel'),
            null,
            $t('message_essweb_system_operation_export_exportOutLabel')
          ).then((res) => {
            if (res) showExportOut = true;
          })
        "
      >
        <!-- julia bug1038 -->
        <svg-icon size="24" iconClass="export" />
        <!-- {{ $t("label_essweb_RosterRecord_list_exportOutBtnLabel") }} -->
      </v-btn>
      <v-btn
        icon
        class="primary mr-4"
        color="white"
        width="40"
        height="40"
        v-if="!Number(RosterRecordData.is_submitted) && curTab == 'tab-2'"
        @click="showExportIn = !showExportIn"
      >
        <!-- julia bug1038 -->
        <svg-icon size="24" iconClass="import" />
        <!-- {{ $t("label_essweb_RosterRecord_list_exportInBtnLabel") }} -->
      </v-btn>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="mr-4 text-capitalize"
            :class="
              !RosterRecordData.status_uuid ||
              RosterRecordData.status_uuid == 'Publishing' ||
              RosterRecordData.status_uuid == 'Submiting' ||
              loading
                ? 'grey'
                : 'primary'
            "
            color="white"
            v-on="on"
            v-bind="attrs"
            v-if="!Number(RosterRecordData.is_locked) == 1 && curStep != 3"
            :disabled="
              !RosterRecordData.status_uuid ||
              RosterRecordData.status_uuid == 'Publishing' ||
              RosterRecordData.status_uuid == 'Submiting' ||
              loading
            "
            icon
            width="40"
            :loading="loading"
            height="40"
            @click.stop="toStep(curStep)"
          >
            <!-- julia bug1038 -->
            <span class="material-icons-round">send</span>
          </v-btn>
        </template>
        {{
          curStep == 0
            ? $t("label_essweb_RosterFormRecord_form_draftLabel")
            : curStep == 1
            ? $t("label_essweb_RosterFormRecord_form_publicLabel")
            : curStep == 2
            ? $t("label_essweb_RosterFormRecord_form_submitLabel")
            : ""
        }}
      </v-tooltip>
    </template>
    <!-- content -->
    <template v-slot:page-main>
      <!-- 改为新的 发布按钮 mel buglist1493 v-if="false"-->
      <v-container class="d-flex" fluid v-if="false">
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              class="primary mr-2"
              color="white"
              v-on="on"
              width="40"
              height="40"
              @click.stop="
                $confirmDo(
                  $t('label_essweb_admin_RosterFormRecord_list_title')
                ).then((res) => {
                  res ? toDeleteRecord() : null;
                })
              "
            >
              <span class="material-icons-round">delete</span>
            </v-btn>
          </template>
          <span>{{
            $t("message_essweb_list_components_tools_delBtnTip")
          }}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              class="primary mr-2"
              color="white"
              v-on="on"
              width="40"
              height="40"
              v-show="!iSEdited"
              @click.stop="iSEdited = true"
            >
              <span class="material-icons-round">edit</span>
            </v-btn>
          </template>
          <span>{{
            $t("message_essweb_list_components_tools_editBtnTip")
          }}</span>
        </v-tooltip>
      </v-container>
      <Taber
        :curTab="curTab"
        @change="(tab) => (curTab = tab)"
        :items="taber"
        special
        contentBackground="mrc-grey pa-0"
      >
        <template v-slot:content-1>
          <div class="max-width rounded-lg transparent">
            <v-tabs
              vertical
              v-model="lefttab"
              background-color="var(--taber-nav-color)"
              class="mrc-grey"
              hide-slider
            >
              <v-sheet height="8" width="150" class="rounded-t-lg"></v-sheet>
              <v-tab
                class="
                  text-capitalize
                  px-3
                  mr-2
                  d-inline-block
                  text-left text--primary
                "
                style="width: 150px; line-height: 48px"
                :style="{ backgroundColor: lefttab == 0 ? '#E6F0FF' : '' }"
                :class="lefttab == 0 ? ' ' : 'white '"
                >{{
                  $t("label_essweb_RosterFormRecord_form_tab_infoLabel")
                }}</v-tab
              >
              <v-tab
                class="
                  text-capitalize
                  px-3
                  mr-2
                  d-inline-block
                  text-left text--primary
                "
                style="width: 150px; line-height: 48px"
                :style="{ backgroundColor: lefttab == 1 ? '#E6F0FF' : '' }"
                :class="lefttab == 1 ? ' ' : 'white '"
                >{{
                  $t("label_essweb_RosterFormRecord_form_tab_detailLabel")
                }}</v-tab
              >
              <v-tab
                class="
                  text-capitalize
                  px-3
                  mr-2
                  d-inline-block
                  text-left text--primary
                "
                style="width: 150px; line-height: 48px"
                :style="{ backgroundColor: lefttab == 2 ? '#E6F0FF' : '' }"
                :class="lefttab == 2 ? ' ' : 'white '"
                >{{
                  $t("label_essweb_RosterFormRecord_form_tab_flowLabel")
                }}</v-tab
              >
              <v-sheet height="8" width="150" class="rounded-b-lg"></v-sheet>
              <v-tab-item class="mrc-grey rounded-lg">
                <v-card class="mrc-grey rounded-lg" :elevation="0">
                  <v-card-text class="transparent pa-0 rounded-lg">
                    <v-form
                      ref="form"
                      lazy-validation
                      :class="iSEdited ? 'rounded-lg' : 'rounded-t-lg'"
                      class="white pa-3 fill-height scroll_content"
                    >
                      <v-row>
                        <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                          <normalInputTextFiled
                            :readonly="!iSEdited"
                            :filled="iSEdited"
                            v-model="RosterRecordData.roster_form_record_title"
                            :label="
                              $t(
                                'label_essweb_RosterFormRecord_form_rosterNameLabel'
                              )
                            "
                            :rules="$GetRules(['_Require_Rules'], [null])"
                            dense
                          />
                        </v-col>
                        <v-col xs="12" sm="6" md="6" lg="6" cols="12">
                          <v-sheet class="text--secondary">{{
                            $t(
                              "label_essweb_RosterFormRecord_form_startDateLabel"
                            )
                          }}</v-sheet>
                          <v-text-field
                            filled
                            dense
                            disabled
                            single-line
                            v-model="RosterRecordData.roster_utc_start_date"
                            :label="
                              $t(
                                'label_essweb_RosterFormRecord_form_startDateLabel'
                              )
                            "
                          ></v-text-field>
                        </v-col>
                        <v-col xs="12" sm="6" md="6" lg="6" cols="12">
                          <v-sheet class="text--secondary">{{
                            $t(
                              "label_essweb_RosterFormRecord_form_endDateLabel"
                            )
                          }}</v-sheet>
                          <v-text-field
                            filled
                            dense
                            disabled
                            single-line
                            v-model="RosterRecordData.roster_utc_end_date"
                            :label="
                              $t(
                                'label_essweb_RosterFormRecord_form_endDateLabel'
                              )
                            "
                          ></v-text-field>
                        </v-col>
                        <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                          <normalInputTextFiled
                            :readonly="!iSEdited"
                            :filled="iSEdited"
                            v-model="
                              RosterRecordData.roster_form_record_description
                            "
                            :label="
                              $t(
                                'label_essweb_RosterFormRecord_form_descriptionLabel'
                              )
                            "
                          />
                        </v-col>
                        <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                          <v-sheet class="text--secondary">{{
                            $t("label_essweb_RosterFormRecord_form_remarkLabel")
                          }}</v-sheet>
                          <v-textarea
                            rows="5"
                            no-resize
                            maxlength="500"
                            counter="500"
                            dense
                            :readonly="!iSEdited"
                            :filled="iSEdited"
                            single-line
                            v-model="RosterRecordData.remarks"
                            name="input-7-4"
                          ></v-textarea>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-card-text>
                  <CardActions
                    saveBtn
                    @save="toSave"
                    v-if="iSEdited"
                    @cancel="toBack(isChanged)"
                  />
                </v-card>
              </v-tab-item>
              <v-tab-item class="rounded-lg transparent">
                <v-card class="rounded-lg" rounded-lg elevation="0">
                  <v-card-text
                    class="rounded-lg scroll_content_y"
                    :style="{
                      maxHeight: $vuetify.breakpoint.height - 251 + 'px',
                    }"
                  >
                    <!-- <v-container class="white pa-3 ma-0 rounded-lg"> -->
                    <div class="title pa-2">
                      {{
                        $t(
                          "label_essweb_RosterFormRecord_form_table_managerTitle"
                        )
                      }}
                    </div>
                    <Tabler :headers="manageHeaders" :items="ManageList" border>
                      <template v-slot:item.staff_name="{ item }">
                        <v-list-item dense two-line class="pa-0">
                          <v-list-item-avatar size="36" class="mr-1 my-0 pa-0">
                            <StaffAvatar
                              size="36"
                              :src="item.mrbase_sys_staffs.staff_avatar"
                              :staff_name="
                                item.mrbase_sys_staffs.preferred_name
                              "
                            />
                          </v-list-item-avatar>
                          <v-list-item-content>
                            <v-list-item-title class="text--primary">
                              {{
                                $getCommonLangValue(
                                  item.mrbase_sys_staffs.preferred_name
                                )
                              }}
                              <span class="text--secondary text-caption-xs">
                                {{ item.mrbase_sys_staffs.staff_code }}</span
                              >
                            </v-list-item-title>
                            <v-list-item-subtitle class="text--secondary">
                              {{
                                $getCommonLangValue(
                                  item.mrbase_sys_staffs.mrbase_sys_job_posts
                                    .job_post_name
                                ) +
                                " - " +
                                item.mrbase_sys_staffs.mrbase_sys_org_levels
                                  .org_level_all
                              }}
                            </v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </template>
                      <template v-slot:item.staff_id="{ item }">
                        {{ item.mrbase_sys_staffs.staff_code }}
                      </template>
                      <template v-slot:item.action="{ item }">
                        <v-btn
                          icon
                          small
                          @click="onDelete('manage', item)"
                          v-if="iSEdited"
                        >
                          <span class="material-icons-round">delete</span>
                        </v-btn>
                      </template>
                    </Tabler>
                    <v-sheet class="px-4">
                      <!-- <v-divider></v-divider> -->
                      <v-btn
                        text
                        small
                        v-if="iSEdited"
                        color="primary"
                        class="text-capitalize"
                        @click="onNew('manage')"
                      >
                        {{
                          $t(
                            "label_essweb_RosterFormRecord_form_table_newManagerBtnLabel"
                          )
                        }}
                        <span class="material-icons-round">add</span>
                      </v-btn>
                    </v-sheet>
                    <!-- <SpecialTable
                      isHead
                      class="max-width"
                      title="Manager"
                      :headers="manageHeaders"
                      tableTitle="manager"
                      type="manage"
                      @onDelete="onDelete"
                      @onNew="onNew"
                      :height="200"
                      :items="ManageList"
                      newBtn="Manager"
                    ></SpecialTable>-->
                    <div class="title pa-2">
                      {{
                        $t(
                          "label_essweb_RosterFormRecord_form_table_staffTitle"
                        )
                      }}
                    </div>
                    <Tabler :headers="staffHeaders" :items="StaffList" border>
                      <template v-slot:item.staff_name="{ item }">
                        <v-list-item dense two-line class="pa-0">
                          <v-list-item-avatar size="36" class="mr-1 my-0 pa-0">
                            <StaffAvatar
                              size="36"
                              :src="item.mrbase_sys_staffs.staff_avatar"
                              :staff_name="
                                item.mrbase_sys_staffs.preferred_name
                              "
                            />
                          </v-list-item-avatar>
                          <v-list-item-content>
                            <v-list-item-title class="text--primary">
                              {{
                                $getCommonLangValue(
                                  item.mrbase_sys_staffs.preferred_name
                                )
                              }}
                              <span class="text--secondary text-caption-xs">
                                {{ item.mrbase_sys_staffs.staff_code }}</span
                              >
                            </v-list-item-title>
                            <v-list-item-subtitle class="text--secondary">
                              {{
                                $getCommonLangValue(
                                  item.mrbase_sys_staffs.mrbase_sys_job_posts
                                    .job_post_name
                                ) +
                                " - " +
                                item.mrbase_sys_staffs.mrbase_sys_org_levels
                                  .org_level_all
                              }}
                            </v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </template>
                      <template v-slot:item.staff_id="{ item }">
                        {{ item.mrbase_sys_staffs.staff_code }}
                      </template>
                      <template v-slot:item.action="{ item }">
                        <v-btn
                          icon
                          small
                          @click="onDelete('staff', item)"
                          v-if="iSEdited"
                        >
                          <span class="material-icons-round">delete</span>
                        </v-btn>
                      </template>
                    </Tabler>
                    <v-sheet class="px-4">
                      <!-- <v-divider></v-divider> -->
                      <v-btn
                        text
                        v-if="iSEdited"
                        small
                        color="primary"
                        class="text-capitalize"
                        @click="onNew('staff')"
                      >
                        {{
                          $t(
                            "label_essweb_RosterFormRecord_form_table_newStaffLabel"
                          )
                        }}
                        <span class="material-icons-round">add</span>
                      </v-btn>
                    </v-sheet>
                    <!-- <SpecialTable
                      isHead
                      class="max-width"
                      title="Staff"
                      :headers="staffHeaders"
                      @onDelete="onDelete"
                      @onNew="onNew"
                      tableTitle="staff"
                      type="staff"
                      :height="260"
                      :items="StaffList"
                      newBtn="Staff"
                    ></SpecialTable>-->
                    <div class="title pa-2">
                      {{
                        $t(
                          "label_essweb_RosterFormRecord_form_table_shiftTitle"
                        )
                      }}
                    </div>
                    <Tabler :headers="shiftHeaders" :items="ShiftList" border>
                      <template v-slot:item.shift_name="{ item }">
                        <div class="balck--text table-title">
                          {{ $getCommonLangValue(item.shift_name) }}
                        </div>
                      </template>
                      <template v-slot:item.shift_time="{ item }">
                        <div class="balck--text table-title">
                          {{
                            $timeMachine(item.start_utc_time) +
                            " - " +
                            $timeMachine(item.end_utc_time)
                          }}
                        </div>
                      </template>
                      <template v-slot:item.action="{ item }">
                        <v-btn
                          icon
                          small
                          @click="onDelete('shift', item)"
                          v-if="iSEdited"
                        >
                          <span class="material-icons-round">delete</span>
                        </v-btn>
                      </template>
                    </Tabler>
                    <v-sheet class="px-4">
                      <!-- <v-divider></v-divider> -->
                      <v-btn
                        text
                        v-if="iSEdited"
                        small
                        color="primary"
                        class="text-capitalize"
                        @click="onNew('shift')"
                      >
                        {{
                          $t(
                            "label_essweb_RosterFormRecord_form_table_newShiftLabel"
                          )
                        }}
                        <span class="material-icons-round">add</span>
                      </v-btn>
                    </v-sheet>
                    <!-- <SpecialTable
                      isHead
                      class="max-width"
                      title="Shift"
                      :headers="shiftHeaders"
                      tableTitle="shift"
                      @onDelete="onDelete"
                      @onNew="onNew"
                      type="shift"
                      :height="260"
                      :items="ShiftList"
                      newBtn="Shift"
                    ></SpecialTable>-->
                    <!-- </v-container> -->
                  </v-card-text>
                  <!-- <CardActions saveBtn @save="toSave" @cancel="toBack" /> -->
                </v-card>
              </v-tab-item>
              <v-tab-item>
                <v-card class="pa-0 rounded-lg" elevation="0">
                  <v-card-text class="pa-0 rounded-lg">
                    <v-container class="white pa-3 ma-0 rounded-lg">
                      <SpecialTable
                        :isHead="false"
                        readonly
                        class="max-width mb-8"
                        :title="
                          $t(
                            'label_essweb_rosterFormRecord_form_list_generationTitle'
                          )
                        "
                        :headers="otherHeaders"
                        :tableTitle="
                          $t(
                            'label_essweb_rosterFormRecord_form_list_generationTitle'
                          )
                        "
                        type="other1"
                        :newBtn="''"
                        :items="GenerationList"
                      ></SpecialTable>
                      <SpecialTable
                        :isHead="false"
                        readonly
                        class="max-width mb-8"
                        :title="
                          $t(
                            'label_essweb_rosterFormRecord_form_list_submitTitle'
                          )
                        "
                        :headers="otherHeaders"
                        :tableTitle="
                          $t(
                            'label_essweb_rosterFormRecord_form_list_submitTitle'
                          )
                        "
                        type="other2"
                        :items="SubmitList"
                        :newBtn="''"
                      ></SpecialTable>
                      <v-row dense>
                        <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                          <AutoComplete
                            label="label_essweb_RosterPropertyGroup_list_title"
                            :items="RosterPropertyGroup"
                            item-text="roster_property_group_name"
                            item-value="uuid"
                            disabled
                            :rules="$GetRules(['_Require_Rules'], [null])"
                            hide-details
                            messages="View Property"
                            v-model="
                              RosterRecordData.roster_property_group_uuid
                            "
                          >
                          </AutoComplete>
                          <v-btn
                            text
                            class="text-capitalize pa-0"
                            x-small
                            @click="showPropertyDialog = true"
                            :disabled="
                              !RosterRecordData.roster_property_group_uuid
                            "
                            color="primary"
                            >{{
                              $t(
                                "label_essweb_shift_form_dialog_viewPropertyLabel"
                              )
                            }}</v-btn
                          >
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                  <!-- <CardActions saveBtn @save="toSave" @cancel="toBack" /> -->
                </v-card>
              </v-tab-item>
            </v-tabs>
          </div>
        </template>
        <template v-slot:content-2>
          <v-card class="fill-height max-width pa-0 elevation-0">
            <v-card-text class="fill-height max-width pa-2 pt-3">
              <RosterPlan
                :Roster_uuid="Roster_uuid"
                :change="isChange"
                :iSEdited="iSEdited"
                :shiftList="ShiftList"
                :startTime="RosterRecordData.roster_utc_start_date"
                :endTime="RosterRecordData.roster_utc_end_date"
              />
            </v-card-text>
          </v-card>
        </template>
      </Taber>
    </template>
    <!-- tools -->
    <template v-slot:tools-main>
      <normalDialog
        deleteModel
        :dialog="showDelete"
        :title="deleteTitle"
        @close="showDelete = false"
        @confirm="toDelete"
      />
      <newShift
        :show="showEditShift"
        :curShiftList="curShiftList"
        @onSave="onSaveShift"
        @close="showEditShift = false"
      />
      <newManager
        :show="showEditManager"
        :curManageList="curManageList"
        @onSave="onSaveManager"
        @close="showEditManager = false"
      />
      <newStaff
        :show="showEditStaff"
        @onSave="onSaveStaff"
        :curStaffList="curStaffList"
        @close="showEditStaff = false"
      />
      <viewPropertyGroup
        :show="showPropertyDialog"
        :group_uuid="RosterRecordData.roster_property_group_uuid"
        @closeDialog="showPropertyDialog = false"
      />
      <selectSender
        :show="showSender"
        :staff_uuid="curStaff"
        @onSave="toSennderDelete"
        :status="curStep"
        :uuid="Roster_uuid"
        @need="
          (sender) => {
            curSender = sender;
            needSender = false;
          }
        "
        @noSender="
          (no) => {
            noSender = no;
          }
        "
        @close="showSender = false"
      />
      <ExportIn
        :show="showExportIn"
        @close="showExportIn = false"
        :curUuid="Roster_uuid"
        @export="onExportEnd"
      />
      <ExportOut
        :show="showExportOut"
        :curUuid="Roster_uuid"
        @export="exportOut"
        @close="showExportOut = false"
        :startTime="RosterRecordData.roster_utc_start_date"
        :endTime="RosterRecordData.roster_utc_end_date"
      />
    </template>
  </ContentLayout>
</template>

<script>
import { mapGetters } from "vuex";
import newShift from "@/Page/EssAdmin/Roster/RosterFormRecord/components/newShift";
import RosterPlan from "@/Page/EssAdmin/Roster/RosterFormRecord/components/RosterPlan";
import newStaff from "@/Page/EssAdmin/Roster/RosterFormRecord/components/newStaff";
import newManager from "@/Page/EssAdmin/Roster/RosterFormRecord/components/newManager";
import selectSender from "@/Page/EssAdmin/Roster/RosterFormRecord/components/selectSender";
import viewPropertyGroup from "@/Page/EssAdmin/Roster/RosterFormRecord/components/viewPropertyGroup";
import ExportIn from "@/Page/EssAdmin/Roster/RosterFormRecord/components/ExportIn";
import ExportOut from "@/Page/EssAdmin/Roster/RosterFormRecord/components/ExportOut";
export default {
  name: "editRosterRecord",
  components: {
    RosterPlan,
    viewPropertyGroup,
    newStaff,
    ExportIn,
    selectSender,
    newShift,
    newManager,
    ExportOut,
  },
  computed: {
    ...mapGetters(["companyLang"]),
    Roster_uuid() {
      return this.$route.params.id;
    },
    RosterPropertyGroup() {
      return this.$getSelectTrans(
        this.RosterPropertyGroupData,
        "roster_property_group_name"
      );
    },
    curStaffList() {
      var arr = [];
      this.StaffList.forEach((item) => {
        arr.push(item.staff_uuid.toString());
      });
      return arr;
    },
    curShiftList() {
      var arr = [];
      this.ShiftList.forEach((item) => {
        arr.push(item.shift_uuid.toString());
      });
      return arr;
    },
    curManageList() {
      var arr = [];
      this.ManageList.forEach((item) => {
        arr.push(item.manager_uuid.toString());
      });
      return arr;
    },
  },
  data() {
    return {
      RosterRecordTitle: null,
      iSEdited: false,
      curSender: [],
      isChanged: false,
      needSender: true,
      showExportOut: false,
      noSender: false,
      lefttab: 0,
      showSender: false,
      willStep: null,
      curStaff: null,
      showExportIn: false,
      curTab: "tab-1",
      taber: [
        "label_essweb_RosterFormRecord_form_step_generalLabel",
        "label_essweb_RosterFormRecord_form_step_rosterPlanLabel",
      ],
      deleteTitle: "",
      pubish_is_require_approval: 1, //发布后是否需要审批 1 需要， 0不需要
      submit_is_require_approval: 1, //  提交后是否需要审批 1 需要， 0不需要
      showEditManager: false,
      showEditStaff: false,
      showEditShift: false,
      mapToDiag: false,
      tabindex: 0,
      curStep: 0,
      isChange: 0,
      curActiveType: null,
      curPorpertyID: null,
      curAction: "new",
      curPorperty: null,
      page: 1,
      loading: false,
      ManageList: [],
      StaffList: [],
      staffLoading: false,
      ShiftList: [],
      GenerationList: [],
      SubmitList: [],
      headers: [],
      showDelete: false,
      RosterRecordData: {
        roster_form_record_swift_number: "",
        roster_form_record_title: "",
        roster_form_record_description: "",
        roster_utc_start_date: "",
        roster_start_time_zone: "480",
        roster_utc_end_date: "",
        roster_end_time_zone: "480",
        generation_utc_datetime: "",
        generation_time_zone: "480",
        is_published: "0",
        publish_utc_deadline: "",
        publish_deadline_zone: "",
        publish_utc_datetime: "",
        publish_time_zone: "",
        is_pre_submitted: "0",
        pre_submission_utc_deadline: "",
        pre_submission_deadline_zone: "",
        pre_submission_utc_datetime: "",
        pre_submission_time_zone: "",
        is_submitted: "0",
        submission_utc_deadline: "",
        submission_deadline_zone: "",
        submission_utc_datetime: "",
        submission_time_zone: "",
        is_locked: "0",
        lock_utc_datetime: "",
        lock_time_zone: "",
        form_type_uuid: "",
        manager_uuid: "5",
        status_uuid: "",
        publish_flow_task_uuid: "",
        submission_flow_task_uuid: "",
        roster_form_uuid: "",
        roster_property_group_uuid: "",
        remarks: "",
      },
      showPropertyDialog: false,
      RosterPropertyGroupData: [],
      desserts: [],
      manageHeaders: [
        {
          text: "label_essweb_RosterFormRecord_form_table_staffNameLabbel",
          value: "staff_name",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_RosterFormRecord_form_rable_staffIdLabel",
          value: "staff_id",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_list_components_tools_actionLabel",
          value: "action",
          align: "end",
          sortable: false,
        },
      ],
      staffHeaders: [
        {
          text: "label_essweb_RosterFormRecord_form_table_staffNameLabbel",
          value: "staff_name",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_RosterFormRecord_form_rable_staffIdLabel",
          value: "staff_id",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_list_components_tools_actionLabel",
          value: "action",
          align: "end",
          sortable: false,
        },
      ],
      shiftHeaders: [
        {
          text: "label_essweb_RosterFormRecord_form_table_shiftNameLabel",
          value: "shift_name",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_RosterFormRecord_form_table_shiftTimeLabel",
          value: "shift_time",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_list_components_tools_actionLabel",
          value: "action",
          align: "end",
          sortable: false,
        },
      ],
      otherHeaders: [
        {
          text: "label_essweb_rosterFormRecord_form_list_statusLabel",
          value: "status",
          width: 200,
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_rosterFormRecord_form_list_dateTimeLabel",
          value: "time",
          align: "start",
          sortable: false,
        },
      ],
    };
  },
  watch: {},
  mounted() {
    const that = this;
    // this.RosterRecordData.roster_form_record_title = this.$getCommonLangKey(
    //   this.companyLang
    // );
    // this.RosterRecordData.roster_form_record_description = this.$getCommonLangKey(
    //   this.companyLang
    // );
    this.getBtnPermissionList();
    this.getInfo();
    this.getPropertyType();
    this.getManageList();
    this.getStaffList();
    this.getShiftList();
    // this.getPorpertyList();
  },
  methods: {
    onExportEnd(success) {
      if (success) {
        this.isChange = Math.random() * 10000; //触发RosterPlan 更新
      }
    },
    exportOut(staff, start, end) {
      let data = {
        staff_uuid: staff.join(","),
        start_time: this.$getTimeValue(start),
        end_time: this.$getTimeValue(end),
      };
      this.showExportOut = false;
      this.$Request({
        method: "POST",
        table: "ess_att_roster",
        url: "/roster-record/export/",
        data: data,
        type: "export",
        export_title: this.$t("label_essweb_RosterRecord_export_title", {
          start: start,
          end: end,
        }),
      });
    },
    toStep: function (step) {
      this.willStep = step;
      if (step == 2) {
        if (Number(this.submit_is_require_approval) && !this.noSender)
          if (this.needSender) this.showSender = true;
          else this.toSennderDelete(this.curSender);
        else this.toSennderDelete(null);
      }
      if (step == 1) {
        if (Number(this.pubish_is_require_approval) && !this.noSender)
          if (this.needSender) this.showSender = true;
          else this.toSennderDelete(this.curSender);
        else this.toSennderDelete(null);
      }
    },
    toSennderDelete: function (sender) {
      this.onStep(this.willStep, sender);
    },
    getPropertyType: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_att_roster_property_group",
        url: "/roster-property-group/get-list/",
      }).then((res) => {
        that.RosterPropertyGroupData = res.data;
      });
    },
    getInfo: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_att_roster_form_records",
        url: "/roster-record/get-details/",
        data: {
          uuid: this.$route.params.id,
        },
      }).then((res) => {
        that.curStaff = res.data.applicant_staff_uuid;
        that.RosterRecordTitle = res.data.roster_form_record_title;
        that.pubish_is_require_approval = Number(
          res.data.pubish_is_require_approval
        );
        that.submit_is_require_approval = Number(
          res.data.submit_is_require_approval
        );
        if (res.data.is_published == 0) {
          that.curStep = 1;
        }
        if (res.data.is_published == 1) {
          that.curStep = 2;
        }
        if (res.data.is_submitted == 1) {
          that.curStep = 3;
        }
        res.data.roster_utc_start_date = that.$getDateTime(
          res.data.roster_utc_start_date,
          "YYYY-MM-DD"
        );
        res.data.roster_utc_end_date = that.$getDateTime(
          res.data.roster_utc_end_date,
          "YYYY-MM-DD"
        );

        that.GenerationList.push({
          status: "label_essweb_rosterFormRecord_form_list_generateLabel",
          time: {
            zone: that.$getUtcByCode(res.data.generation_time_zone),
            time: that.$getDateTime(
              res.data.generation_utc_datetime,
              "YYYY/MM/DD HH:mm"
            ),
          },
        });
        that.GenerationList.push({
          status: "label_essweb_rosterFormRecord_form_list_publishLabel",
          time: {
            zone: that.$getUtcByCode(res.data.publish_time_zone),
            time: that.$getDateTime(
              res.data.publish_utc_datetime,
              "YYYY/MM/DD HH:mm"
            ),
          },
        });
        that.GenerationList.push({
          status: "label_essweb_rosterFormRecord_form_list_approveLabel",
          time: {
            zone: that.$getUtcByCode(res.data.publish_approval_time_zone),
            time: that.$getDateTime(
              res.data.publish_approval_datetime,
              "YYYY/MM/DD HH:mm"
            ),
          },
        });
        that.SubmitList.push({
          status: "label_essweb_rosterFormRecord_form_list_generateLabel",
          time: {
            zone: that.$getUtcByCode(res.data.submission_time_zone),
            time: that.$getDateTime(
              res.data.submission_utc_datetime,
              "YYYY/MM/DD HH:mm"
            ),
          },
        });

        that.SubmitList.push({
          status: "label_essweb_rosterFormRecord_form_list_approveLabel",
          time: {
            zone: that.$getUtcByCode(res.data.submission_approval_time_zone),
            time: that.$getDateTime(
              res.data.submission_approval_datetime,
              "YYYY/MM/DD HH:mm"
            ),
          },
        });
        // res.data["roster_form_record_title_save"] =
        //   res.data.roster_form_record_title;
        // res.data.roster_form_record_title = that.$transOnLineCommonLangKey(
        //   that.companyLang,
        //   res.data.roster_form_record_title
        // );
        // res.data["roster_form_record_description_save"] =
        //   res.data.roster_form_record_description;
        // res.data.roster_form_record_description = that.$transOnLineCommonLangKey(
        //   that.companyLang,
        //   res.data.roster_form_record_description
        // );
        that.RosterRecordData = res.data;
      });
    },
    getStaffList: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_att_roster_form_records_detail_subordinate",
        url: "/roster-record-subordinate/get-list/",
        data: {
          roster_form_record_uuid: this.$route.params.id,
        },
      }).then((res) => {
        that.StaffList = res.data;
      });
    },
    getManageList: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_att_roster_form_records_detail_supervisor",
        url: "/roster-record-manager/get-list/",
        data: {
          roster_form_record_uuid: this.$route.params.id,
        },
      }).then((res) => {
        that.ManageList = res.data;
      });
    },
    getShiftList: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_att_roster_form_records_detail_shift",
        url: "/roster-record-shift/get-list/",
        data: {
          roster_form_record_uuid: this.$route.params.id,
        },
      }).then((res) => {
        that.ShiftList = res.data;
      });
    },
    onSaveManager: function (arr) {
      const that = this;
      var curUuids = [];
      var newUuids = [];
      this.ManageList.forEach((item) => {
        curUuids.push(item.uuid);
      });
      arr.forEach((item) => {
        newUuids.push({
          manager_uuid: item.staff_id,
          roster_form_record_uuid: that.$route.params.id,
        });
      });
      // if (curUuids.length) {
      //   this.$Request({
      //     method: "POST",
      //     table: "ess_att_roster_form_records_detail_supervisor",
      //     url:
      //       "/roster-record-supervisor/delete-roster-record-supervisor-table/",
      //     data: {

      //       uuids: curUuids.join(","),
      //     },
      //   }).then((res) => {
      //     that.ManageList = [];
      //   });
      // }
      if (newUuids.length) {
        this.$Request({
          method: "POST",
          table: "ess_att_roster_form_records_detail_manager",
          url: "/roster-record-manager/add/",
          data: {
            uuid: that.$route.params.id,
            ess_att_roster_form_records_detail_manager: newUuids,
          },
        }).then((res) => {
          that.getManageList();
          that.isChange = Math.random() * 10000; //触发RosterPlan 更新
        });
      }
    },
    onSaveStaff: function (arr) {
      const that = this;
      var curUuids = [];
      var newUuids = [];
      this.StaffList.forEach((item) => {
        curUuids.push(item.uuid);
      });
      arr.forEach((item) => {
        newUuids.push({
          staff_uuid: item.staff_id,
          roster_form_record_uuid: that.$route.params.id,
        });
      });
      // if (curUuids.length) {
      //   this.$Request({
      //     method: "POST",
      //     table: "ess_att_roster_form_records_detail_subordinate",
      //     url:
      //       "/roster-record-subordinate/delete-roster-record-subordinate-table/",
      //     data: {

      //       uuids: curUuids.join(","),
      //       roster_form_record_uuid: that.$route.params.id,
      //     },
      //   }).then((res) => {
      //     that.StaffList = [];
      //   });
      // }
      if (newUuids.length) {
        this.$Request({
          method: "POST",
          table: "ess_att_roster_form_records_detail_subordinate",
          url: "/roster-record-subordinate/add/",
          data: {
            uuid: that.$route.params.id,

            ess_att_roster_form_records_detail_subordinate: newUuids,
          },
        }).then((res) => {
          that.getStaffList();
          that.isChange = Math.random() * 10000; //触发RosterPlan 更新
        });
      }
    },
    onSaveShift: function (arr) {
      const that = this;
      var curUuids = [];
      var newUuids = [];
      this.ShiftList.forEach((item) => {
        curUuids.push(item.uuid);
      });
      arr.forEach((item) => {
        newUuids.push({
          shift_uuid: item.shift_uuid, //
          roster_form_record_uuid: that.$route.params.id,
        });
      });
      // if (curUuids.length) {
      //   this.$Request({
      //     method: "POST",
      //     table: "ess_att_roster_form_records_detail_shift",
      //     url: "/roster-record-shift/delete/",
      //     data: {

      //       uuids: curUuids.join(","),
      //     },
      //   }).then((res) => {
      //     that.ShiftList = [];
      //   });
      // }
      if (newUuids.length) {
        this.$Request({
          method: "POST",
          table: "ess_att_roster_form_records_detail_shift",
          url: "/roster-record-shift/add/",
          data: {
            uuid: that.$route.params.id,

            ess_att_roster_form_records_detail_shift: newUuids,
          },
        }).then((res) => {
          that.getShiftList();
          that.isChange = Math.random() * 10000; //触发RosterPlan 更新
        });
      }
    },
    onDelete: function (type, item) {
      const that = this;
      that.curActiveType = type;
      switch (type) {
        case "manage":
          that.deleteTitle = that.$t(
            "label_essweb_RosterFormRecord_form_table_managerTitle"
          );
          that.curPorpertyID = item.uuid;
          break;
        case "staff":
          that.deleteTitle = that.$t(
            "label_essweb_RosterFormRecord_form_table_staffTitle"
          );
          that.curPorpertyID = item.uuid;
          break;
        case "shift":
          that.deleteTitle = that.$t(
            "label_essweb_RosterFormRecord_form_table_shiftTitle"
          );
          that.curPorpertyID = item.uuid;
          break;
        default:
          break;
      }
      this.$confirmDo(this.deleteTitle).then((res) => {
        if (res) that.toDelete();
      });
    },
    onNew: function (type) {
      const that = this;
      that.curActiveType = type;
      switch (type) {
        case "manage":
          that.showEditManager = true;
          break;
        case "shift":
          that.showEditShift = true;
          break;
        case "staff":
          that.showEditStaff = true;
          break;
        default:
          break;
      }
    },
    onNewProperty: function (obj) {},
    onEditProperty: function (obj) {},
    toNewMapping: function () {
      const that = this;
      this.curAction = "edit";
      this.curPorperty = [];
      //
    },
    // 获取送办人
    getStaff: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess",
        url: "/approval/get-sender-list/",
        data: {
          uuid: this.$route.params.id,
          data_type: 3,
          approval_sequence: this.curStep == 1 ? 1 : 2, //2
        },
      }).then((res) => {});
    },
    onStep: function (step, sender) {
      const that = this;
      that.loading = true;
      that.showSender = false;
      let data = {
        uuid: this.$route.params.id,
      };
      if (sender != null) {
        data["sender_uuid"] = sender.join(",");
      }
      this.$Request({
        method: "POST",
        table: "ess",
        url: step === 1 ? "/roster-record/publish/" : "/roster-record/submit/",
        data: data,
      })
        .then((res) => {
          that.$showMessage({
            type: "success",
            text:
              step === 1
                ? that.$t(
                    "message_essweb_RosterFormRecord_form_publicSuccessLabel"
                  )
                : that.$t(
                    "message_essweb_RosterFormRecord_form_submitSuccessLabel"
                  ),
          });
          this.$Sleep(1000).then(() => {
            that.curStep = that.curStep + 1;
            if (that.curStep == 2)
              that.RosterRecordData["status_uuid"] = "Publishing";
            if (that.curStep == 3)
              that.RosterRecordData["status_uuid"] = "Submiting";
            that.loading = false;
            that.getInfo();
          });
        })
        .catch(() => {
          that.loading = false;
        });
    },
    getPorpertyList: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "",
        url: "",
        data: {
          holiday_group_uuid: this.$route.params.id,
        },
      }).then((res) => {
        that.desserts = res.data;
      });
    },
    toBack: function (change) {
      if (change)
        this.$confirmWarn(
          this.$t("message_tips"),
          this.$t("message_essweb_form_textField_refuseChange_title")
        ).then((res) => {
          if (res) {
            if (this.iSEdited) {
              this.iSEdited = false;
              this.getInfo();
            } else {
              this.$router.back();
            }
          }
        });
      else {
        if (this.iSEdited) {
          this.iSEdited = false;
          this.getInfo();
        } else {
          this.$router.back();
        }
      }
    },
    toDeleteRecord: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_att_roster_form_records",
        url: "/roster-record/delete/",
        data: {
          uuids: this.$route.params.id,
        },
      }).then((res) => {
        that.$showMessage({
          text: that.$t(
            "message_essweb_RosterFormRecord_list_deleteRosterFormRecordSuccessLabel"
          ),
          type: "success",
        });
        that.toBack();
      });
    },
    toSave: function () {
      const that = this;
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      this.$Request({
        method: "POST",
        table: "ess_att_roster_form_records",
        url: "/roster-record/update/",
        data: {
          uuid: this.$route.params.id,
          roster_form_record_title:
            this.RosterRecordData.roster_form_record_title,
          roster_form_record_description:
            this.RosterRecordData.roster_form_record_description,
          remarks: this.RosterRecordData.remarks,
        },
      }).then((res) => {
        that.toBack();
        that.$showMessage({
          text: that.$t(
            "message_essweb_RosterFormRecord_list_updateRosterFormRecordSuccessLabel"
          ),
          type: "success",
        });
      });
    },
    toDelete: function () {
      const that = this;
      this.showDelete = false;
      var url = "",
        table = "",
        text = "";
      var data = {
        uuids: that.curPorpertyID,
      };
      switch (that.curActiveType) {
        case "staff":
          url = "/roster-record-subordinate/delete/";
          table = "ess_att_roster_form_records_detail_subordinate";
          data = {
            uuids: that.curPorpertyID,
            roster_form_record_uuid: that.$route.params.id,
          };
          text = that.$t(
            "message_essweb_RosterFormRecord_list_deleteStaffSuccessLabel"
          );
          break;
        case "shift":
          url = "/roster-record-shift/delete/";
          table = "ess_att_roster_form_records_detail_shift";
          text = that.$t(
            "message_essweb_RosterFormRecord_list_deleteShiftSuccessLabel"
          );
          break;
        case "manage":
          url = "/roster-record-manager/delete/";
          table = "ess_att_roster_form_records_detail_supervisor";
          text = that.$t(
            "message_essweb_RosterFormRecord_list_deleteManagerSuccessLabel"
          );
          break;
        default:
          break;
      }
      this.$Request({
        method: "POST",
        table: table,
        url: url,
        data: data,
      }).then((res) => {
        that.$showMessage({
          text: text,
          type: "success",
        });
        if (that.curActiveType == "manage") {
          that.ManageList = that.ManageList.filter(
            (ele) => ele.uuid !== that.curPorpertyID
          );
        }
        if (that.curActiveType == "shift") {
          that.ShiftList = that.ShiftList.filter(
            (ele) => ele.uuid !== that.curPorpertyID
          );
        }
        if (that.curActiveType == "staff") {
          that.StaffList = that.StaffList.filter(
            (ele) => ele.uuid !== that.curPorpertyID
          );
        }
        that.isChange = Math.random() * 10000; //触发RosterPlan 更新
      });
    },
  },
};
</script>
